import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { projectsActions } from '../../actions';
import {
  AddChatActionPayload,
  CreateNewChatActionPayload,
} from '../../typedefs';
import { book } from '@routes/book';
import { PayloadActionWithPromiseNavigateMeta } from '@core/FinalForm/typedefs';

export function* createNewChat({
  payload,
  meta: { resolve, reject, navigate },
}: PayloadActionWithPromiseNavigateMeta<CreateNewChatActionPayload>) {
  try {
    yield effects.put(projectsActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: 'chats/', body },
    ]);
    if (!response.ok) {
      reject();
      yield throwError(response);
    }

    const data: AddChatActionPayload = yield effects.call([response, 'json']);
    yield effects.put(
      projectsActions.addChat({ data, projectId: payload.project_id }),
    );
    resolve(data);
    navigate(`${book.chat}/${payload.projectName}/${data.id}`);
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(projectsActions.stopFetching());
  }
}
